import { post } from '@uipath/portal-shell-util';
import { TrackUserEvent } from '@uipath/telemetry-client-web/models';

import { TelemetryEventMap } from '../../models/appInsights/eventMap';
import { getOrganizationStandardUrl } from '../orgStandardUrlHelper';
import Logger from './logger';

export async function trackStatsigEvent<T extends keyof TelemetryEventMap>(
    token: string,
    event: T,
    value?: TelemetryEventMap[T] & TrackUserEvent,
) {
    const url = `${getOrganizationStandardUrl()}/abTesting/statsig/trackEvent`;
    await post(
        url,
        {
            token,
            body: {
                event,
                value,
            },
        },
        (e) => {
            Logger.debug([ 'statsig' ], `Failed to track statsig event: ${e.message}`);
        },
    );
}
